import { Outlet, useLocation } from "react-router-dom";
import { useUserStore } from "../../hooks/userHooks/user.hooks";
import { getValue } from "../../utils/object.utils";
import { isUserRoleValidForNavigation } from "../../roleConfig";

export const AuthenticationRoute = () => {
  const { user } = useUserStore();

  const userRole = getValue(user, "role", "");

  const location = useLocation();
  const path = getValue(location, "pathname");

  // if (!isRolePermitted) {
  //   return <Navigate to={Paths.Dashboard} replace />;
  // }

  return <Outlet />;
};
